import { Box, CircularProgress, IconButton } from '@mui/material';
import { DynamicIcon, Tooltip } from 'src/components';

const exportIconWrapperSx = {
  width: '1.25rem',
  height: '1.25rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

type ExportPricingButtonProps = {
  disabled: boolean;
  isExporting: boolean;
  onClick: () => void;
  ariaLabel?: string;
  ariaDescribedBy?: string;
};

export const ExportPricingButton = ({
  disabled,
  isExporting,
  onClick,
  ariaLabel = 'Export pricing',
  ariaDescribedBy,
}: ExportPricingButtonProps) => (
  <Tooltip title="Export pricing">
    <span>
      <IconButton
        data-testid="membership-config-export-pricing-button"
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        size="small"
        disabled={disabled}
        onClick={onClick}
      >
        <Box sx={exportIconWrapperSx}>
          {isExporting ? (
            <CircularProgress size={16} thickness={5} />
          ) : (
            <DynamicIcon name="download" library="lucide" />
          )}
        </Box>
      </IconButton>
    </span>
  </Tooltip>
);
